// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ixKCSR {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.q49IPq {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.wsLAJp {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.qR6Elt {
  background-color: var(--neutral-dark-opacity-50) !important;
}

.xHsyTP {
  padding: var(--spacing-3) var(--spacing-2) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.qtjV_A {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.exwQpy {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
  flex: 1;
}

.xpLitn {
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  min-height: 0;
  flex: 1;
}

.LnJG9R {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  overflow-y: auto;
}

.My75KV {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
}

.hsc0Fm {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.naU55b {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  border-top: none;
  background-color: var(--surface-neutral-white);
  flex-shrink: 0;
}

.LsycX5 {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/EmissorOrderFilters/EmissorOrderFilterDrawer.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.backdrop {\n  background-color: var(--neutral-dark-opacity-50) !important;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-2) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  flex: 1;\n}\n\n.modalBody {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  overflow: hidden;\n  min-height: 0;\n  flex: 1;\n}\n\n.content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  overflow-y: auto;\n}\n\n.competence {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n}\n\n.label {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.modalFooter {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n  border-top: none;\n  background-color: var(--surface-neutral-white);\n  flex-shrink: 0;\n}\n\n.action {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ixKCSR`,
	"modalDialog": `q49IPq`,
	"modalContent": `wsLAJp`,
	"backdrop": `qR6Elt`,
	"modalHeader": `xHsyTP`,
	"backButton": `qtjV_A`,
	"modalTitle": `exwQpy`,
	"modalBody": `xpLitn`,
	"content": `LnJG9R`,
	"competence": `My75KV`,
	"label": `hsc0Fm`,
	"modalFooter": `naU55b`,
	"action": `LsycX5`
};
module.exports = ___CSS_LOADER_EXPORT___;
